@if (data?.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}
<div mat-dialog-content>
  <div class="container-fluid">
    <!-- <div class="row">
    <div class="col-12">
    </div>
  </div>
</div> -->
  </div>
</div>
<div mat-dialog-actions align="end">
  <button
    role="button"
    type="button"
    aria-label="Download Now"
    mat-button
    (click)="download()"
    cdkFocusInitial
  >
    Download Now
  </button>
  <button
    role="button"
    type="button"
    aria-label="Download Later"
    mat-button
    (click)="dialogRef.close('no')"
  >
    Download Later
  </button>
</div>
